import { Astrolabe, OrbitSketch } from '../CelestialPatterns'

const INSTRUMENTS = [
  { title: 'Astrology', description: 'Decode your birth chart.' },
  { title: 'Palmistry', description: 'Read the story in your hands.' },
  { title: 'Tarot', description: 'Find clarity for the present.' },
]

const STEPS = [
  { number: '01', title: 'Choose a reading.' },
  { number: '02', title: 'Share your details.' },
  { number: '03', title: 'Receive AI insights.' },
]

const InstrumentsPanel = () => {
  return (
    <section
      className="w-screen h-screen flex-shrink-0 relative overflow-hidden"
      style={{ background: '#CBB191' }}
    >
      <div className="grain-overlay" />

      <div className="absolute top-8 right-8 pointer-events-none">
        <OrbitSketch />
      </div>
      <div className="absolute bottom-[-40px] left-[-40px] pointer-events-none">
        <Astrolabe size={300} />
      </div>

      <div className="relative z-10 flex flex-col h-full px-5 sm:px-8 lg:px-[5%] xl:px-[7%] pt-[80px] sm:pt-[84px] lg:pt-[88px] pb-5 sm:pb-6 lg:pb-8 overflow-y-auto lg:overflow-hidden">

        <div className="flex-1 flex flex-col lg:flex-row gap-5 sm:gap-6 lg:gap-0 items-stretch min-h-0">

          {/* Photo — visible on all screens */}
          <div className="w-full lg:w-[38%] xl:w-[42%] flex-shrink-0">
            <div
              className="relative w-full overflow-hidden h-[180px] lg:h-full"
              style={{ borderRadius: '12px', border: '1px solid #A98C6B' }}
            >
              <img
                src="/images/assets/img2.jpg"
                alt="Astrology editorial"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          {/* Content */}
          <div className="w-full lg:w-[62%] xl:w-[58%] flex flex-col justify-center lg:pl-10 xl:pl-16 min-h-0">

            <div className="mb-5 sm:mb-8 flex-shrink-0">
              <h2
                className="font-serif font-light tracking-[-0.02em] mb-3"
                style={{ fontSize: 'clamp(1.4rem, 3.5vw, 3.5rem)', lineHeight: '1.05', color: '#2B2017' }}
              >
                Three Inputs.<br />
                One Insight.
              </h2>
              <p
                className="leading-relaxed max-w-md"
                style={{ fontSize: 'clamp(0.8rem, 0.95vw, 1rem)', color: '#5A4636' }}
              >
                Every reading combines multiple systems to deliver personalized guidance.
              </p>
            </div>

            <div className="flex flex-col mb-6 sm:mb-9 flex-shrink-0">
              {INSTRUMENTS.map((inst, i) => (
                <div
                  key={i}
                  className="flex gap-4 sm:gap-7 py-3 sm:py-5"
                  style={{ borderBottom: '1px solid #A98C6B' }}
                >
                  <h3
                    className="font-sans font-medium w-24 sm:w-32 flex-shrink-0"
                    style={{ fontSize: 'clamp(0.8rem, 1vw, 1rem)', color: '#2B2017' }}
                  >
                    {inst.title}
                  </h3>
                  <p
                    className="leading-relaxed"
                    style={{ fontSize: 'clamp(0.78rem, 0.9vw, 0.92rem)', color: '#5A4636' }}
                  >
                    {inst.description}
                  </p>
                </div>
              ))}
            </div>

            <div className="flex-shrink-0">
              <h3
                className="font-serif font-light tracking-[-0.01em] mb-3 sm:mb-4"
                style={{ fontSize: 'clamp(1rem, 2vw, 1.8rem)', color: '#2B2017' }}
              >
                How It Works
              </h3>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-0">
                {STEPS.map((step, i) => (
                  <div
                    key={i}
                    className="flex items-start gap-3 sm:gap-4 sm:px-5 first:sm:pl-0 last:sm:pr-0 sm:border-r last:border-r-0"
                    style={{ borderColor: '#A98C6B' }}
                  >
                    <span
                      className="font-mono golden-text flex-shrink-0 leading-none mt-0.5"
                      style={{ fontSize: 'clamp(0.65rem, 0.7vw, 0.75rem)' }}
                    >
                      {step.number}
                    </span>
                    <span
                      className="font-sans"
                      style={{ fontSize: 'clamp(0.75rem, 0.85vw, 0.88rem)', color: '#2B2017' }}
                    >
                      {step.title}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default InstrumentsPanel
